import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { useQuery } from 'react-apollo';
import Spin from 'components/common/Spin';
import { GET_STUDENT } from 'graphql/lc/students';
import Timeline from './timeline';
import Schools from 'modules/student/school';
import ExercisesList from './exercise/List';
import ExerciseForm from '../student/worksheets/ExerciseForm';
import SnapshotTable from '../../components/snapshot';
import StudentProfile from '../../components/student-profile';
import Schedule from '../admin/students/Schedule';
import StudentStats from 'components/student-stats';
import Essays from 'modules/student/essays';
import CommonApp from 'modules/student/common-app';
import ChatBubble from 'components/pages/messages/chat/Bubble';
import Team from '../admin/team';
import { GET_STUDENT_PROFILE } from 'graphql/student/Profile';
import StudentFiles from 'components/student-files'

const StudentRoutes = ({ match }) => {
  const { data, loading } = useQuery(GET_STUDENT, {
    fetchPolicy: 'network-only',
    variables: { user_id: Number(match.params.id) },
  });

  const { data: profileData } = useQuery(GET_STUDENT_PROFILE, {
    variables: { id: match.params.id },
  });

  if (loading) return <Spin linear spinning />;

  const student = data.users[0];
  const profile = profileData?.student_profile[0];

  if (!student) return <div>Student not found</div>;

  if (!profile) return <Spin spinning linear />;

  student.sub = student.user_cognito_sub;
  student.id = student.user_id;
  student.fname = student.user_first_name;
  student.lname = student.user_last_name;
  student.email = student.user_email
  student.curriculum_id = profile.curriculum_id;

  const room = student.chat_rooms.find((r) => r.room_name === 'coaches');

  return (
    <div>
      {room && <ChatBubble room={room} />}
      <Switch>
        <Route
          path="/students/:id/profile"
          render={(props) => <StudentProfile {...props} student={student} />}
        />
        <Route
          path="/students/:id/team"
          render={(props) => <Team {...props} student={student} />}
        />
        <Route
          path="/students/:id/schedule"
          render={(props) => <Schedule {...props} student={student} canEdit />}
        />
        <Route
          path="/students/:id/timeline"
          render={(props) => (
            <Timeline
              {...props}
              student={{
                ...student,
                parents_info: profileData?.student_profile[0]?.guardians,
              }}
            />
          )}
        />
        <Route
          path="/students/:id/common-app"
          render={(props) => <CommonApp {...props} student={student} />}
        />
        <Route
          path="/students/:id/essays"
          render={(props) => <Essays {...props} student={student} />}
        />
        <Route
          path="/students/:id/schools"
          render={(props) => (
            <Schools
              {...props}
              student={{
                ...student,
                highschool_info:
                  profileData?.student_profile[0]?.highschool_info,
              }}
            />
          )}
        />
        <Route
          path="/students/:id/snapshot"
          render={(props) => <SnapshotTable {...props} student={student} />}
        />
        <Route
          path="/students/:id/stats"
          render={(props) => <StudentStats {...props} student={student} />}
        />
        <Route
          path="/students/:id/files"
          render={(props) => <StudentFiles {...props} student={student} />}
        />
        <Route
          exact
          path="/students/:userId/exercises/:id/view"
          render={(props) => <ExerciseForm {...props} studentId={student.id} />}
        />
        <Route
          path="/students/:id/exercises/:moduleId?"
          render={(props) => <ExercisesList {...props} student={student} />}
        />
      </Switch>
    </div>
  );
};

export default StudentRoutes;
